import React, { useState, useEffect } from 'react'

import { Checkbox } from 'components/common'
import s from './OrderModal.module.css'

interface OptionSettings {
  optionName: string
  optionSet: {
    id: string
    itemName: string
    additionalCost: number
    quantity: number
  }[]
}

interface IProps {
  optionData: {
    description: string
    id: string
    max_select: number
    name: string
    required: boolean
    values: {
      cost: number
      has_cost: boolean
      id: string
      name: string
    }[]
  }
  allSelectedOptions: any
  setAllSelectedOptions: React.Dispatch<React.SetStateAction<any[]>>
  setRequireCheckArr: React.Dispatch<React.SetStateAction<any[]>>
  currency: string
}

const CheckBoxOptions = ({
  optionData,
  allSelectedOptions,
  setAllSelectedOptions,
  setRequireCheckArr,
  currency
}: IProps) => {
  const [optionSettings, setOptionSettings] = useState<OptionSettings>({
    optionName: '',
    optionSet: []
  })

  useEffect(() => {
    if (Object.keys(optionSettings).length) {
      if (allSelectedOptions.length) {
        setAllSelectedOptions([
          ...allSelectedOptions.filter(
            (selectedOption) =>
              selectedOption.optionName !== optionSettings.optionName
          ),
          optionSettings
        ])
      } else {
        setAllSelectedOptions([optionSettings])
      }
    }

    setRequireCheckArr((requireCheckArr) => [
      ...requireCheckArr.filter((item) => item.id !== optionData.id),
      {
        id: optionData.id,
        decent:
          optionSettings?.optionSet?.length <= optionData.max_select &&
          !!optionSettings?.optionSet?.length,
        itemName: optionData.name
      }
    ])
  }, [optionSettings])

  // required true olduğu durum
  const optionChangeHandler = (value, maxSelect, optionName) => {
    const optionSetLength = optionSettings?.optionSet?.length

    if (optionSetLength) {
      if (
        optionSettings.optionSet.findIndex(
          (optionValue) => optionValue.id === value.id
        ) !== -1
      ) {
        // işaretli checkboxu silmek
        setOptionSettings({
          optionName,
          optionSet: optionSettings.optionSet.filter(
            (optionValue) => optionValue.id !== value.id
          )
        })

        return
      }

      // Eğer lengthi varsa max lengthine göre ekleme yapıcaz max length i aşıyorsa ilk eleman silenecek
      if (optionSetLength + 1 > maxSelect) {
        setOptionSettings({
          optionName,
          optionSet: [
            ...optionSettings.optionSet.slice(1),
            {
              id: value.id,
              itemName: value.name,
              additionalCost: value.cost,
              quantity: 1
            }
          ]
        })
      } else {
        setOptionSettings({
          optionName,
          optionSet: [
            ...optionSettings.optionSet,
            {
              id: value.id,
              itemName: value.name,
              additionalCost: value.cost,
              quantity: 1
            }
          ]
        })
      }
    } else {
      setOptionSettings({
        optionName,
        optionSet: [
          {
            id: value.id,
            itemName: value.name,
            additionalCost: value.cost,
            quantity: 1
          }
        ]
      })
    }
  }

  return (
    <div>
      {optionData.values.map((value) => (
        <div className={s.row}>
          <Checkbox
            onChange={() =>
              optionChangeHandler(value, optionData.max_select, optionData.name)
            }
            id={value.name}
            checked={
              optionSettings?.optionSet?.length &&
              optionSettings?.optionSet?.findIndex(
                (optionValue) => value.id === optionValue.id
              ) !== -1
            }
          />

          <label className={s.label} for={value.name}>
            <span>{value.name}</span>
            {value.has_cost && (
              <span style={{ color: 'green', marginLeft: '10px' }}>
                {`${currency.trim()}${value.cost}`}
              </span>
            )}
          </label>
        </div>
      ))}
    </div>
  )
}

export default CheckBoxOptions
